(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-carousel"] && !window.DesignMode) return;
  try {
    
  var slider_dom = document.querySelector(".carousel-slider");
  var list_dom = document.querySelectorAll(".carousel-slider>div");
  var dots_dom = document.querySelectorAll(".carouse-dots div");
  slider_dom.style.height = list_dom[0].offsetHeight + 'px';

  function isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
    return mobileKeywords.test(userAgentInfo);
  }

  var style_list = [
    {
      left: '-41%'
    },
    {
      left: '20%'
    },
    {
      left: '81%'
    }
  ];
  var flag = true; // 节流阀
  var currentIndex = 0;
  
  move();
  setInterval(function() {
    if (currentIndex > 1) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    move();
  },5000);

  for (var i = 0; i < dots_dom.length; i++) {
    var dot = dots_dom[i];
    dot.index = i;
    dot.onclick = function() {
      currentIndex = this.index;
      move();
    }
  }
  
  
  function move() {
    dots_dom.forEach(function (d) {
      d.classList.remove('active');
    });
    dots_dom[currentIndex].classList.add('active');
    
    if (isMobile()) {
      list_dom.forEach(function (l) {
        l.classList.remove('active');
      });
      list_dom[currentIndex].classList.add('active');
    } else {
      if(flag) {
        flag = false; // 关闭节流阀 等到动画结束了才能继续执行点击操作
      }
      var current_style_list = [];
      if (currentIndex === 0) {
        current_style_list = [style_list[1],style_list[2], style_list[0]];
      } else if(currentIndex === 1) {
        current_style_list = [style_list[0],style_list[1], style_list[2]];
      } else if(currentIndex === 2) {
        current_style_list = [style_list[2],style_list[0], style_list[1]];
      }
      for(var i = 0; i < list_dom.length; i++) {
        animate(list_dom[i], current_style_list[i], function() {
         flag = true;  // 回调函数，当动画执行完 再把节流阀打开
        });
      }
    }
  }

  function animate(obj, json, callback) {
    clearInterval(obj.timer);
    obj.timer = setInterval(function() {
      var bool = true;
      for(var attr in json) {
        obj.style[attr] = json[attr];
      }
      if(bool) {
        clearInterval(obj.timer);
        callback && callback();
      }
    },15);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate-steps"] && !window.DesignMode) return;
  try {
    
  window.onload = function() {
    function isMobile() {
      var userAgentInfo = navigator.userAgent;
      var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
      return mobileKeywords.test(userAgentInfo);
    }
    
    var lf_dom = document.querySelector(".btns-row .btn-box:nth-child(1)");
    var rt_dom = document.querySelector(".btns-row .btn-box:nth-child(2)");
    var list_dom = document.querySelector(".affiliate-steps");
    var item_dom = document.querySelector(".affiliate-steps .steps-item");
    var item_width = item_dom.offsetWidth;
    var currentIndex = 0;

    if (isMobile()) {
      lf_dom.onclick = function() {
        currentIndex = currentIndex < 1 ? 3 : currentIndex - 1;
        list_dom.style.transform = 'translateX(-' + item_width*currentIndex + 'px)';
      }
      rt_dom.onclick = function() {
        currentIndex = currentIndex > 2 ? 0 : currentIndex + 1;
        list_dom.style.transform = 'translateX(-' + item_width*currentIndex + 'px)';
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auto-images-carousel"] && !window.DesignMode) return;
  try {
    
  var slider_dom = document.querySelector(".carousel-slider");
  var list_dom = document.querySelectorAll(".carousel-slider>div");
  var dots_dom = document.querySelectorAll(".carouse-dots div");
  slider_dom.style.height = list_dom[0].offsetHeight + 'px';

  function isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
    return mobileKeywords.test(userAgentInfo);
  }

  var style_list = [
    {
      left: '-41%'
    },
    {
      left: '20%'
    },
    {
      left: '81%'
    }
  ];
  var flag = true; // 节流阀
  var currentIndex = 0;
  
  move();
  setInterval(function() {
    if (currentIndex > 1) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    move();
  },1500);

  for (var i = 0; i < dots_dom.length; i++) {
    var dot = dots_dom[i];
    dot.index = i;
    dot.onclick = function() {
      currentIndex = this.index;
      move();
    }
  }
  
  
  function move() {
    dots_dom.forEach(function (d) {
      d.classList.remove('active');
    });
    dots_dom[currentIndex].classList.add('active');
    
    if (isMobile()) {
      list_dom.forEach(function (l) {
        l.classList.remove('active');
      });
      list_dom[currentIndex].classList.add('active');
    } else {
      if(flag) {
        flag = false; // 关闭节流阀 等到动画结束了才能继续执行点击操作
      }
      var current_style_list = [];
      if (currentIndex === 0) {
        current_style_list = [style_list[1],style_list[2], style_list[0]];
      } else if(currentIndex === 1) {
        current_style_list = [style_list[0],style_list[1], style_list[2]];
      } else if(currentIndex === 2) {
        current_style_list = [style_list[2],style_list[0], style_list[1]];
      }
      for(var i = 0; i < list_dom.length; i++) {
        animate(list_dom[i], current_style_list[i], function() {
         flag = true;  // 回调函数，当动画执行完 再把节流阀打开
        });
      }
    }
  }

  function animate(obj, json, callback) {
    clearInterval(obj.timer);
    obj.timer = setInterval(function() {
      var bool = true;
      for(var attr in json) {
        obj.style[attr] = json[attr];
      }
      if(bool) {
        clearInterval(obj.timer);
        callback && callback();
      }
    },15);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-image-tab-2"] && !window.DesignMode) return;
  try {
    
  // document.addEventListener("DOMContentLoaded", (event) => {
  //   window.addEventListener("load", function(e){

  //       let sectionsTwo = gsap.utils.toArray(".media-before-after-two");
  //       const tTwo = gsap.to(sectionsTwo, { xPercent: -100 * (sectionsTwo.length - 1), paused: true, ease: "none" });
      
  //       ScrollTrigger.create({
  //         trigger: "#before-after-tab-two",
  //         start: "center center",
  //         end: "+=1000",
  //         pinSpacing: true,
  //         fastScrollEnd: true,
  //         pin: "#before-after-tab-two",
  //         pinnedContainer: "#before-after-tab-two",
  //         onUpdate: (selfTwo) => {
  //           gsap.to(tTwo, { progress: selfTwo.progress, duration: 1 });
  //         }
  //       });
      
  //   });
  // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-image-tab"] && !window.DesignMode) return;
  try {
    
  // document.addEventListener("DOMContentLoaded", (event) => {
  //   window.addEventListener("load", function(e){

  //       let sectionsOne = gsap.utils.toArray(".media-before-after-one");
  //       const tOne = gsap.to(sectionsOne, { xPercent: -100 * (sectionsOne.length - 1), paused: true, ease: "none" });
  //       ScrollTrigger.create({
  //         trigger: "#before-after-tab-one",
  //         start: "center center",
  //         end: "+=1000",
  //         pinSpacing: true,
  //         fastScrollEnd: true,
  //         pin: "#before-after-tab-one",
  //         pinnedContainer: "#before-after-tab-one",
  //         onUpdate: (selfOne) => {
  //           gsap.to(tOne, { progress: selfOne.progress, duration: 1 });
  //         }
  //       });
      
  //   });
  // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["business-hair"] && !window.DesignMode) return;
  try {
    
  function isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
    return mobileKeywords.test(userAgentInfo);
  }

  if (isMobile()) {
    var salon_video_dom = document.querySelector(".business-hair-salon .salon-lf");
    salon_video_dom.style.height = window.innerWidth + 'px';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["business-home"] && !window.DesignMode) return;
  try {
    
  window.onload = function() {
    function isMobile() {
      var userAgentInfo = navigator.userAgent;
      var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
      return mobileKeywords.test(userAgentInfo);
    }
    
    var lf_dom = document.querySelector(".btns-row .btn-box:nth-child(1)");
    var rt_dom = document.querySelector(".btns-row .btn-box:nth-child(2)");
    var list_dom = document.querySelector(".business-home");
    var item_dom = document.querySelector(".business-home .product-item");
    var item_width = item_dom.offsetWidth;
    var currentIndex = 0;

    if (isMobile()) {
      lf_dom.onclick = function() {
        currentIndex = currentIndex < 1 ? 2 : currentIndex - 1;
        list_dom.style.transform = 'translateX(-' + item_width*currentIndex + 'px)';
      }
      rt_dom.onclick = function() {
        currentIndex = currentIndex > 1 ? 0 : currentIndex + 1;
        list_dom.style.transform = 'translateX(-' + item_width*currentIndex + 'px)';
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certification-carousel"] && !window.DesignMode) return;
  try {
    
  var slider_dom = document.querySelector(".carousel-slider");
  var list_dom = document.querySelectorAll(".carousel-slider>.slider-item");
  var dots_dom = document.querySelectorAll(".carousel-dots>.dots-item");

  function isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
    return mobileKeywords.test(userAgentInfo);
  }
  
  var flag = true; // 节流阀
  var currentIndex = 0;
  
  move();
  setInterval(function() {
    if (currentIndex > 1) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    move();
  },5000);

  for (var i = 0; i < dots_dom.length; i++) {
    var dot = dots_dom[i];
    dot.index = i;
    dot.onclick = function() {
      currentIndex = this.index;
      move();
    }
  }
  
  
  function move() {
    dots_dom.forEach(function (d) {
      d.classList.remove('active');
    });
    dots_dom[currentIndex].classList.add('active');
    
    list_dom.forEach(function (l) {
      l.classList.remove('active');
    });
    console.log(list_dom[currentIndex]);
    list_dom[currentIndex].classList.add('active');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certification-shop"] && !window.DesignMode) return;
  try {
    
  var list_dom = document.querySelectorAll(".certification-shop .product-item");
  var dots_dom = document.querySelectorAll(".carouse-dots>div");
  
  var flag = true; // 节流阀
  var currentIndex = 0;

  move();
  setInterval(function() {
    if (currentIndex > 1) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    move();
  },5000);
  
  for (var i = 0; i < dots_dom.length; i++) {
    var dot = dots_dom[i];
    dot.index = i;
    dot.onclick = function() {
      currentIndex = this.index;
      move();
    }
  }
  
  function move() {
    if (flag) {
      flag = false;

      dots_dom.forEach(function (d) {
        d.classList.remove('active');
      });
      dots_dom[currentIndex].classList.add('active');
      
      list_dom.forEach(function (l) {
        l.classList.remove('active');
      });
      list_dom[currentIndex].classList.add('active');
      
      flag = true;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certification"] && !window.DesignMode) return;
  try {
    
  function isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
    return mobileKeywords.test(userAgentInfo);
  }
  
  var popup_close_dom = document.querySelectorAll(".certification-popup .popup-close");
  popup_close_dom.forEach(function (item) {
    item.onclick = function() {
      this.parentNode.parentNode.classList.remove('open');
    }
  });
  
  var link_dom = document.querySelectorAll(".certification-item-txt-lf-btn a ");
  link_dom.forEach(function (item) {
    item.onclick = function() {
      event.stopPropagation();
    }
  });
  
  var list_dom = document.querySelectorAll(".certification-list .certification-item");
  var list_btn_dom = document.querySelectorAll(".certification-list .certification-item .certification-item-btn");
  var flag = true; // 节流阀
  
  list_dom.forEach(function (item) {
    item.onclick = function() {
      move(this);
      if (!isMobile()) {
        this.nextElementSibling.classList.add('open');
      }
    }
    if (!isMobile()) {
      item.onmouseover = function() {
        move(this);
      }
    }
  });

  if (isMobile()) {
    list_btn_dom.forEach(function (item) {
      item.onclick = function() {
        this.parentNode.parentNode.nextElementSibling.classList.add('open');
      }
    });
  }
  
  function move(el) {
    if (flag) {
      flag = false;

      var imgs_height = el.offsetHeight;
      for (var i = 0; i < el.parentNode.children.length; i++) {
        el.parentNode.children[i].classList.remove('active');
      }
      el.classList.add('active');
      el.style.height = imgs_height + 'px';
      
      flag = true;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comment-carousel"] && !window.DesignMode) return;
  try {
    

  var arr_default = [
         {   // 1
             left: 0,
             opacity: 70,
                scale: 0.8,
                // zIndex: 1,
         },
         {   // 2
             left: 32.1,
             opacity: 100,
                scale: 1,
                // zIndex: 2,
         },
         {   // 3  中间图片
             left: 64.2,
             opacity: 70,
                scale: 0.8,
                // zIndex: 1,
         },
     ];
  var arr = [
         {   // 1
             left: 0,
             opacity: 70,
                scale: 0.8,
                // zIndex: 1,
         },
         {   // 2
             left: 32.1,
             opacity: 100,
                scale: 1,
                // zIndex: 2,
         },
         {   // 3  中间图片
             left: 64.2,
             opacity: 70,
                scale: 0.8,
                // zIndex: 1,
         },
     ];
     var slider = document.querySelector(".slider");
     var lis = slider.querySelectorAll("li");
     var arrow_l = slider.querySelector(".arrow-l");
     var arrow_r = slider.querySelector(".arrow-r");
     var dots = document.querySelectorAll(".comment-dots div");
    slider.style.height = lis[0].offsetHeight + 'px';

    function isMobile() {
      var userAgentInfo = navigator.userAgent;
      
      // 正则表达式匹配常见的移动设备关键字
      var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
      
      return mobileKeywords.test(userAgentInfo);
    }

      var flag = true; // flag节流阀 为了解决点击过快而产生bug
      var currentIndex = 0;
      move(); // 先调用一下，为了刚打开浏览器时渲染页面
      setInterval(function() {
        if (currentIndex > 1) {
          currentIndex = 0;
        } else {
          currentIndex++;
        }
        move();
      },5000);

      for (var i = 0; i < dots.length; i++) {
        var dot = dots[i];
        dot.index = i;
        dot.onclick = function() {
          currentIndex=this.index;
          move();
        }
      }
     // 让每个图片执行动画
     function move() {
        dots.forEach(function (d) {
          d.classList.remove('active');
        });
        dots[currentIndex].classList.add('active');

        if (isMobile()) {
          lis.forEach(function (l) {
            l.classList.remove('active');
          });
          lis[currentIndex].classList.add('active');
        }
        
        if(flag) {
         flag = false; // 关闭节流阀 等到动画结束了才能继续执行点击操作
          if (!isMobile()) {
            if (currentIndex === 0) {
                arr = [arr_default[1],arr_default[2], arr_default[0]];
              } else if(currentIndex === 1) {
                arr = [arr_default[0],arr_default[1], arr_default[2]];
              } else if(currentIndex === 2) {
                arr = [arr_default[2],arr_default[0], arr_default[1]];
              }
             for(var i = 0; i < lis.length; i++) {
               animate(lis[i], arr[i], function() {
                   flag = true;  // 回调函数，当动画执行完 再把节流阀打开'
               });
             }
           }
        }
       
       
     }
     // 动画函数
     function animate(obj, json, callback) {
         clearInterval(obj.timer);
         obj.timer = setInterval(function() {
             var bool = true;
             for(var attr in json) {
                 var icur = 0;
                 if(attr == 'opacity') {
                     icur = Math.round(parseFloat(getStyle(obj, attr)) * 100);
                 } else {
                     icur = parseInt(getStyle(obj, attr));
                 }
                 var speed = (json[attr] - icur) / 10;
                 speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
                 // if(icur != json[attr]) {
                 //     bool = false;
                 // }
                 if (attr == 'opacity') {
                     // obj.style.filter = 'alpha(opacity = '+ (icur + speed) +')';
                     // obj.style.opacity = (icur + speed) / 100;
                     obj.style.opacity = json[attr] / 100;
                 } else if(attr == 'zIndex') {
                     obj.style.zIndex = json[attr];
                 } else if(attr == 'scale') {
                     obj.style.scale = json[attr];
                 } else if(attr == 'left') {
                     obj.style.left = json[attr] + '%';
                 } else {
                     obj.style[attr] = icur + speed + 'px';
                 }
             }
             if(bool) {
                 clearInterval(obj.timer);
                 callback && callback();
             }
         },15);
     }
     // 获取属性函数
     function getStyle(obj, attr) {
         if(obj.currentStyle){   //IE浏览器
             return obj.currentStyle[attr];
         }else{    //chrome、firefox等浏览器
             return getComputedStyle(obj,null)[attr];
         }
     }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  var menu_title = document.querySelectorAll(".footer-wrapper-m .footer-menu-m p");
  var menu_list = document.querySelectorAll(".footer-wrapper-m .footer-menu-m  .v-stack");
  for (var i = 0; i < menu_title.length; i++) {
    var title = menu_title[i];
    title.index = i;
    title.onclick = function() {

      if (this.classList.contains('active')) {
        this.classList.remove('active');
        menu_list[this.index].classList.remove('active');
      } else {
        // this.classList.add('active');
        // menu_list[this.index].classList.add('active');
        
        menu_title.forEach(function (t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
        
        menu_list.forEach(function (l) {
          l.classList.remove('active');
        });
        menu_list[this.index].classList.add('active');
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-removal-index"] && !window.DesignMode) return;
  try {
    
 
        gsap.registerPlugin(ScrollTrigger);
        const parallaxImages = gsap.utils.toArray(".hair-removal-index .image-card-hover");
        // let tl = gsap.timeline({
        //   scrollTrigger: {
        //     trigger: ".hair-removal-index",
        //     pin: true,
        //     //markers: true,
        //     start: "center",
        //     end: ".hair-removal-index",
        //     scrub: 1
        //   }
        // });
        
        // tl.to(
        //     ".hair-removal-index .image-card-hover",
        //     {
        //       xPercent: 100,
        //       scale: 3
        //     }
        //   )

        let HairIndex = document.querySelector(".hair-removal-index"); 
        HairIndex.addEventListener("mousemove", parallax);
        
        function parallax(e) {
          parallaxImages.forEach(function (img) {
            var moving_value = img.dataset.value;
            var x = (e.clientX * moving_value) / 250;
            var y = (e.clientY * moving_value) / 250;
            gsap.set(img, { x });
            gsap.set(img, { y });
          });
        }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-removal"] && !window.DesignMode) return;
  try {
    

    const numberElement = document.getElementById('hair-removal-safe-num');
    const numSafe = gsap.timeline({
        delay: 0.5
    });

    numSafe.to(numberElement, {
        
        duration: 2,
        ease: 'power1.inOut',
        attr: {
            value: 82
        },

        onUpdate: function() {
            numberElement.innerText = Math.round(this.targets()[0].getAttribute('value'));
        }
    });
  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use"] && !window.DesignMode) return;
  try {
    
  // var slider_dom = document.querySelector(".how-to-use-content");
  var list_dom = document.querySelectorAll(".how-to-use-content .use-item");
  var dots_dom = document.querySelectorAll(".how-to-use-dots .dots-step");
  var currentIndex = 0;
  var flag = true; // 节流阀
  
  move();
  setInterval(function() {
    if (currentIndex > dots_dom.length - 2) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    move();
  }, 5000);

  for (var i = 0; i < dots_dom.length; i++) {
    var dot = dots_dom[i];
    dot.index = i;
    dot.onclick = function() {
      currentIndex = this.index;
      move();
    }
  }
  
  
  function move() {
    if (flag) {
      flag = false; // 关闭节流阀 等到动画结束了才能继续执行点击操作
      dots_dom.forEach(function (d) {
        d.classList.remove('active');
      });
      dots_dom[currentIndex].classList.add('active');
      
      list_dom.forEach(function (l) {
        l.classList.remove('active');
      });
      list_dom[currentIndex].classList.add('active');
      flag = true;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-card-coupon"] && !window.DesignMode) return;
  try {
    
let node1 = document.querySelector(".image-card-coupon-div1"); 
let node2 = document.querySelector(".image-card-coupon-div2"); 
node1.addEventListener("mousemove", parallax1);
node2.addEventListener("mousemove", parallax2);
const parallaxImages1 = gsap.utils.toArray(".image-card-coupon-div1 .image-card-coupon-move");
  const parallaxImages2 = gsap.utils.toArray(".image-card-coupon-div2 .image-card-coupon-move");
  
function parallax1(e) {
  parallaxImages1.forEach(function (img) {
    var moving_value = img.dataset.value;
    var x = (e.clientX * moving_value) / 250;
    var y = (e.clientY * moving_value) / 250;
    gsap.set(img, { x });
    gsap.set(img, { y });
  });
}
  function parallax2(e) {
  parallaxImages2.forEach(function (img) {
    var moving_value = img.dataset.value;
    var x = (e.clientX * moving_value) / 250;
    var y = (e.clientY * moving_value) / 250;
    gsap.set(img, { x });
    gsap.set(img, { y });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laser-revive-index"] && !window.DesignMode) return;
  try {
    

        const parallaxImages = gsap.utils.toArray(".laser-revivie-js .image-card-hover");

        let HairIndex = document.querySelector(".laser-revivie-js"); 
        HairIndex.addEventListener("mousemove", parallax);
        
        function parallax(e) {
          parallaxImages.forEach(function (img) {
            var moving_value = img.dataset.value;
            var x = (e.clientX * moving_value) / 250;
            var y = (e.clientY * moving_value) / 250;
            gsap.set(img, { x });
            gsap.set(img, { y });
          });
        }

      const parallaxImages2 = gsap.utils.toArray(".led-mask-section .image-card-hover");

        let HairIndex2 = document.querySelector(".led-mask-section"); 
        HairIndex2.addEventListener("mousemove", parallax2);
        
        function parallax2(e) {
          parallaxImages2.forEach(function (img) {
            var moving_value = img.dataset.value;
            var x = (e.clientX * moving_value) / 250;
            var y = (e.clientY * moving_value) / 250;
            gsap.set(img, { x });
            gsap.set(img, { y });
          });
        }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["led-before-after"] && !window.DesignMode) return;
  try {
    
  var list_dom = document.querySelectorAll(".led-before-after-list .media-before-after");
  var nav_dom = document.querySelectorAll(".led-before-after-nav-list .nav-item");
  var currentIndex = 0;
  var flag = true; // 节流阀
  
  move();
  setInterval(function() {
    if (currentIndex > nav_dom.length - 2) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    move();
  }, 6000);

  for (var i = 0; i < nav_dom.length; i++) {
    var dot = nav_dom[i];
    dot.index = i;
    dot.onclick = function() {
      currentIndex = this.index;
      move();
    }
  }
  
  
  function move() {
    if (flag) {
      flag = false; // 关闭节流阀 等到动画结束了才能继续执行点击操作
      nav_dom.forEach(function (d) {
        d.classList.remove('active');
      });
      nav_dom[currentIndex].classList.add('active');
      
      list_dom.forEach(function (l) {
        l.classList.remove('active');
      });
      list_dom[currentIndex].classList.add('active');
      flag = true;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["led-benefits"] && !window.DesignMode) return;
  try {
    
  var analysis_table_dom = document.querySelector(".revive-analysis");
  var analysis_item_dom = document.querySelector(".revive-analysis .analysis-item");
  var see_more_dom = document.querySelector(".analysis-btns .btns-lf");
  var lf_dom = document.querySelector(".analysis-btns .btns-row .btn-box:nth-child(1)");
  var rt_dom = document.querySelector(".analysis-btns .btns-row .btn-box:nth-child(2)");
  var currentIndex = 0;
  var item_width = analysis_item_dom.offsetWidth;
  
  see_more_dom.onclick = function() {
    if (this.classList.contains('unfold')) {
      this.classList.remove('unfold');
      analysis_table_dom.style.height = '400px';
    } else {
      this.classList.add('unfold');
      analysis_table_dom.style.height = 'auto';
    }
  }
  
  lf_dom.onclick = function() {
    currentIndex = currentIndex < 1 ? 2 : currentIndex - 1;
    analysis_table_dom.scrollLeft = item_width * currentIndex;
  }
  rt_dom.onclick = function() {
    currentIndex = currentIndex > 2 ? 3 : currentIndex + 1;
    analysis_table_dom.scrollLeft = item_width * currentIndex;
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["led-certification"] && !window.DesignMode) return;
  try {
    
  var list_dom = document.querySelector(".oval-section .oval-animation__images");
  // var nav_dom = document.querySelectorAll(".led-before-after-nav-list .nav-item");
  var currentIndex = 0;
  var flag = true; // 节流阀
  
  setInterval(function() {
    if (currentIndex > 3) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    list_dom.classList.remove('oval-0');
    list_dom.classList.remove('oval-1');
    list_dom.classList.remove('oval-2');
    list_dom.classList.remove('oval-3');
    list_dom.classList.remove('oval-4');
    list_dom.classList.remove('oval-5');
    list_dom.classList.add('oval-' + currentIndex);
    list_dom.classList.add('oval-inner');
    setTimeout(function() {
      list_dom.classList.remove('oval-inner');
    }, 1000);
  }, 2000);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-comment-carousel"] && !window.DesignMode) return;
  try {
    

  var arr_default = [
         {   // 1
             left: 0,
             opacity: 70,
                scale: 0.8,
         },
         {   // 2
             left: 32.1,
             opacity: 100,
                scale: 1,
         },
         {   // 3  中间图片
             left: 64.2,
             opacity: 70,
                scale: 0.8,
         },
     ];
  var arr = [
         {   // 1
             left: 0,
             opacity: 70,
                scale: 0.8,
         },
         {   // 2
             left: 32.1,
             opacity: 100,
                scale: 1,
         },
         {   // 3  中间图片
             left: 64.2,
             opacity: 70,
                scale: 0.8,
         },
     ];
     var slider = document.querySelector(".slider");
     var lis = slider.querySelectorAll("li");
     var arrow_l = slider.querySelector(".arrow-l");
     var arrow_r = slider.querySelector(".arrow-r");
     var dots = document.querySelectorAll(".comment-dots div");
    slider.style.height = lis[0].offsetHeight + 'px';

    function isMobile() {
      var userAgentInfo = navigator.userAgent;
      
      // 正则表达式匹配常见的移动设备关键字
      var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
      
      return mobileKeywords.test(userAgentInfo);
    }

      var flag = true; // flag节流阀 为了解决点击过快而产生bug
      var currentIndex = 0;
      move(); // 先调用一下，为了刚打开浏览器时渲染页面
      setInterval(function() {
        if (currentIndex > 1) {
          currentIndex = 0;
        } else {
          currentIndex++;
        }
        move();
      },5000);

      for (var i = 0; i < dots.length; i++) {
        var dot = dots[i];
        dot.index = i;
        dot.onclick = function() {
          currentIndex=this.index;
          move();
        }
      }
     // 让每个图片执行动画
     function move() {
        dots.forEach(function (d) {
          d.classList.remove('active');
        });
        dots[currentIndex].classList.add('active');

        if (isMobile()) {
          lis.forEach(function (l) {
            l.classList.remove('active');
          });
          lis[currentIndex].classList.add('active');
        }
        
        if(flag) {
         flag = false; // 关闭节流阀 等到动画结束了才能继续执行点击操作
          if (!isMobile()) {
            if (currentIndex === 0) {
                arr = [arr_default[1],arr_default[2], arr_default[0]];
              } else if(currentIndex === 1) {
                arr = [arr_default[0],arr_default[1], arr_default[2]];
              } else if(currentIndex === 2) {
                arr = [arr_default[2],arr_default[0], arr_default[1]];
              }
             for(var i = 0; i < lis.length; i++) {
               animate(lis[i], arr[i], function() {
                   flag = true;  // 回调函数，当动画执行完 再把节流阀打开'
               });
             }
           }
        }
       
       
     }
     // 动画函数
     function animate(obj, json, callback) {
         clearInterval(obj.timer);
         obj.timer = setInterval(function() {
             var bool = true;
             for(var attr in json) {
                 var icur = 0;
                 if(attr == 'opacity') {
                     icur = Math.round(parseFloat(getStyle(obj, attr)) * 100);
                 } else {
                     icur = parseInt(getStyle(obj, attr));
                 }
                 var speed = (json[attr] - icur) / 10;
                 speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
                 // if(icur != json[attr]) {
                 //     bool = false;
                 // }
                 if (attr == 'opacity') {
                     // obj.style.filter = 'alpha(opacity = '+ (icur + speed) +')';
                     // obj.style.opacity = (icur + speed) / 100;
                     obj.style.opacity = json[attr] / 100;
                 } else if(attr == 'zIndex') {
                     obj.style.zIndex = json[attr];
                 } else if(attr == 'scale') {
                     obj.style.scale = json[attr];
                 } else if(attr == 'left') {
                     obj.style.left = json[attr] + '%';
                 } else {
                     obj.style[attr] = icur + speed + 'px';
                 }
             }
             if(bool) {
                 clearInterval(obj.timer);
                 callback && callback();
             }
         },15);
     }
     // 获取属性函数
     function getStyle(obj, attr) {
         if(obj.currentStyle){   //IE浏览器
             return obj.currentStyle[attr];
         }else{    //chrome、firefox等浏览器
             return getComputedStyle(obj,null)[attr];
         }
     }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-index"] && !window.DesignMode) return;
  try {
    
  const parallaxImages1 = gsap.utils.toArray(".product-list-index-index-card1 .image-card-move");
  let productIndex1 = document.querySelector(".product-list-index-index-card1"); 
  productIndex1.addEventListener("mousemove", parallax1);
  
  function parallax1(e) {
    parallaxImages1.forEach(function (img) {
      var moving_value = img.dataset.value;
      var x = (e.clientX * moving_value) / 250;
      var y = (e.clientY * moving_value) / 250;
      gsap.set(img, { x });
      gsap.set(img, { y });
    });
  }

  const parallaxImages2 = gsap.utils.toArray(".product-list-index-index-card2 .image-card-move");
  let productIndex2 = document.querySelector(".product-list-index-index-card2"); 
  productIndex2.addEventListener("mousemove", parallax2);
  
  function parallax2(e) {
    parallaxImages2.forEach(function (img) {
      var moving_value = img.dataset.value;
      var x = (e.clientX * moving_value) / 250;
      var y = (e.clientY * moving_value) / 250;
      gsap.set(img, { x });
      gsap.set(img, { y });
    });
  }

  const parallaxImages3 = gsap.utils.toArray(".product-list-index-index-card3 .image-card-move");
  let productIndex3 = document.querySelector(".product-list-index-index-card3"); 
  productIndex3.addEventListener("mousemove", parallax3);
  
  function parallax3(e) {
    parallaxImages3.forEach(function (img) {
      var moving_value = img.dataset.value;
      var x = (e.clientX * moving_value) / 250;
      var y = (e.clientY * moving_value) / 250;
      gsap.set(img, { x });
      gsap.set(img, { y });
    });
  }

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-new"] && !window.DesignMode) return;
  try {
    
  var section_dom = document.querySelector(".product-list-new-section");
  var header_dom = document.querySelector(".header__wrapper");
  var bar_dom = document.querySelector(".announcement-bar");
  
  var settings_dom = document.querySelector(".how-to-choose-settings");
  
  window.addEventListener('scroll',function() { 
    var userAgentInfo = navigator.userAgent;
    var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
    if (mobileKeywords.test(userAgentInfo)) {
      var top = document.documentElement.scrollTop || document.body.scrollTop;
      if(top > 600) {
        // section_dom.style.top = header_dom.offsetHeight + 'px';
        settings_dom.style.marginTop = (section_dom.offsetHeight + header_dom.offsetHeight + bar_dom.offsetHeight + 30) + 'px';
        section_dom.classList.add('show');
      } else {
        settings_dom.style.marginTop = 0;
        section_dom.classList.remove('show');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-carousel-index"] && !window.DesignMode) return;
  try {
    
 
  const productVideoImage = gsap.utils.toArray(".product-video-carousel-index .image-card-move");
  let productVideoIndex = document.querySelector(".product-video-carousel-index"); 
  productVideoIndex.addEventListener("mousemove", parallaxVideo);

  // let V1 = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: ".product-video-carousel-index",
  //       pin: true,
  //       //markers: true,
  //       start: "top-=100",
  //       end: ".product-video-carousel-index",
  //       scrub: 1
  //     }
  //   });
    
    // V1.to(
    //     ".product-video-carousel-index .image-card-hover",
    //     {
    //       yPercent: 100,
    //       scale: 3
    //     }
    //   )
  
  function parallaxVideo(e) {
    productVideoImage.forEach(function (img) {
      var moving_value = img.dataset.value;
      var x = (e.clientX * moving_value) / 250;
      var y = (e.clientY * moving_value) / 250;
      gsap.set(img, { x });
      gsap.set(img, { y });
    });
  }


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-reviews"] && !window.DesignMode) return;
  try {
    
  var list_dom = document.querySelectorAll(".results-reviews .reviews-item");
  var dots_dom = document.querySelectorAll(".carouse-dots div");

  function isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
    return mobileKeywords.test(userAgentInfo);
  }
  var currentIndex = 0;
  
  move();
  setInterval(function() {
    if (currentIndex > dots_dom.length - 2) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    move();
  }, 5000);

  for (var i = 0; i < dots_dom.length; i++) {
    var dot = dots_dom[i];
    dot.index = i;
    dot.onclick = function() {
      currentIndex = this.index;
      move();
    }
  }
  
  
  function move() {
    dots_dom.forEach(function (d) {
      d.classList.remove('active');
    });
    dots_dom[currentIndex].classList.add('active');
    
    if (isMobile()) {
      list_dom.forEach(function (l) {
        l.classList.remove('active');
      });
      list_dom[currentIndex].classList.add('active');
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revive-analysis"] && !window.DesignMode) return;
  try {
    
  var analysis_table_dom = document.querySelector(".revive-analysis");
  var analysis_item_dom = document.querySelector(".revive-analysis .analysis-item");
  var see_more_dom = document.querySelector(".analysis-btns .btns-lf");
  var lf_dom = document.querySelector(".analysis-btns .btns-row .btn-box:nth-child(1)");
  var rt_dom = document.querySelector(".analysis-btns .btns-row .btn-box:nth-child(2)");
  var currentIndex = 0;
  var item_width = analysis_item_dom.offsetWidth;
  
  see_more_dom.onclick = function() {
    if (this.classList.contains('unfold')) {
      this.classList.remove('unfold');
      analysis_table_dom.style.height = '400px';
    } else {
      this.classList.add('unfold');
      analysis_table_dom.style.height = 'auto';
    }
  }
  
  lf_dom.onclick = function() {
    currentIndex = currentIndex < 1 ? 3 : currentIndex - 1;
    analysis_table_dom.scrollLeft = item_width * currentIndex;
  }
  rt_dom.onclick = function() {
    currentIndex = currentIndex > 2 ? 0 : currentIndex + 1;
    analysis_table_dom.scrollLeft = item_width * currentIndex;
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revive-statistics"] && !window.DesignMode) return;
  try {
    
  var circle_lf_dom = document.querySelectorAll(".revive-statistics .statistics-top .circle-percent .circle-lf");
  var circle_rt_dom = document.querySelectorAll(".revive-statistics .statistics-top .circle-percent .circle-rt");
  var circle_num_dom = document.querySelectorAll(".revive-statistics .statistics-top .circle-percent span");
  var percent_dom = document.querySelectorAll(".revive-statistics .statistics-bottom .item-percent span");

  function addWithTwoDecimals(num1, num2) {
    num1 = num1 * 100;
    num2 = num2 * 100;
    
    var sum = num1 + num2;
    
    return (sum / 100).toFixed(2);
  }
  var rotate_end = [86, 82, 86, 86];
  var percent_end = [7.9, 8.63, 12.26];
  var rotate = [0, 0, 0, 0];
  var percent = [0.01, 0.01, 0.01];

  var loop;
  var loop2;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      rotate = [0, 0, 0, 0];
      percent = [0.01, 0.01, 0.01];
      clearInterval(loop);
      clearInterval(loop2);
      if (entry.isIntersecting) {
        executeAction();
      } else {
      }
    });
  });
  const target = document.querySelector(".revive-statistics");
  observer.observe(target);
  
  function executeAction() {
    loop = setInterval(function() {
      for (var i = 0; i < circle_num_dom.length; i++) {
        if (rotate[i] < rotate_end[i]) {
          rotate[i]++;
          if (rotate[i] < 50) {
            circle_rt_dom[i].style.borderColor = '#f5e7de';
            circle_rt_dom[i].style.transform = 'rotate('+ 0 + 'deg)';
            circle_lf_dom[i].style.transform = 'rotate('+ (-180 - 3.6*rotate[i]) + 'deg)';
          } else {
            let index = rotate[i] - 50;
            circle_rt_dom[i].style.borderColor = '#FDBE97';
            circle_lf_dom[i].style.transform = 'rotate('+ -360 + 'deg)';
            circle_rt_dom[i].style.transform = 'rotate('+ (180 - 3.6*index) + 'deg)';
          }
          circle_num_dom[i].innerHTML = `${rotate[i]}%`;
        };
      }
      if (rotate[i] >= 86) clearInterval(loop);
    }, 20);
  
    loop2 = setInterval(function() {
      for (var i = 0; i < percent_dom.length; i++) {
        if (percent[i] < percent_end[i]) {
          percent[i] = addWithTwoDecimals(percent[i], 0.01);
          percent_dom[i].innerHTML = percent[i];
        };
      }
      if (percent[i] >= 12.26) clearInterval(loop2);
    }, 0.0000000001);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revive-use"] && !window.DesignMode) return;
  try {
    
  // var slider_dom = document.querySelector(".revive-use-content");
  var list_dom = document.querySelectorAll(".revive-use-content .use-item");
  var dots_dom = document.querySelectorAll(".revive-use-dots .dots-step");
  var currentIndex = 0;
  var flag = true; // 节流阀
  
  move();
  setInterval(function() {
    if (currentIndex > dots_dom.length - 2) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    move();
  }, 5000);

  for (var i = 0; i < dots_dom.length; i++) {
    var dot = dots_dom[i];
    dot.index = i;
    dot.onclick = function() {
      currentIndex = this.index;
      move();
    }
  }
  
  
  function move() {
    if (flag) {
      flag = false; // 关闭节流阀 等到动画结束了才能继续执行点击操作
      dots_dom.forEach(function (d) {
        d.classList.remove('active');
      });
      dots_dom[currentIndex].classList.add('active');
      
      list_dom.forEach(function (l) {
        l.classList.remove('active');
      });
      list_dom[currentIndex].classList.add('active');
      flag = true;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-tips"] && !window.DesignMode) return;
  try {
    
  // window.onload = function(){
  
  //   function isMobile() {
  //     var userAgentInfo = navigator.userAgent;
  //     var mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;
  //     return mobileKeywords.test(userAgentInfo);
  //   }

  //   if (isMobile()) {
  //     var slider_dom = document.querySelector(".use-tips");
  //     var section_dom = document.querySelector(".use-tips-section");
  //     var section_width = section_dom.offsetWidth - 15;
      
  //     var dots_dom = document.querySelectorAll(".carouse-dots div");
      
      
  //     var flag = true; // 节流阀
  //     var currentIndex = 0;
      
  //     move();
  //     setInterval(function() {
  //       if (currentIndex > 1) {
  //         currentIndex = 0;
  //       } else {
  //         currentIndex++;
  //       }
  //       move();
  //     },5000);
    
    
  //     for (var i = 0; i < dots_dom.length; i++) {
  //       var dot = dots_dom[i];
  //       dot.index = i;
  //       dot.onclick = function() {
  //         currentIndex = this.index;
  //         move();
  //       }
  //     }
      
      
  //     function move() {
  //       if (flag) {
  //         flag = false; // 关闭节流阀 等到动画结束了才能继续执行点击操作
  //         dots_dom.forEach(function (d) {
  //           d.classList.remove('active');
  //         });
  //         dots_dom[currentIndex].classList.add('active');
  //         slider_dom.style.transform="translateX(-" + currentIndex * section_width + "px)";
  //         flag = true;
  //       }
  //     }
  //   }
    
  // }
  

  } catch(e) { console.error(e); }
})();
})();
